<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
      <v-row>
        <v-col class="col-12">
          <core-field
            type='autocomplete'
            @input='updateProtocol'
            :field="protocolField"
            :value="protocol.id"
          />
        </v-col>
        <v-col :colspan="12">
          <material-chart-card
            type='Bar'
            :options="options"
            :data='data'
          />
        </v-col>
      </v-row>

  </v-container>
</template>

<script>
import { reportAvailability } from '@/api/report'
import 'chartist-plugin-legend'
import 'chartist-plugin-pointlabels'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      protocolField: {
        small: true,
        value: 'protocol_id',
        text: 'Protocol',
        type: 'autocomplete',
        title: 'name'
      },
      options: {
        plugins: [
          this.$chartist.plugins.legend({legendNames: ['Available', 'Min Stock']}),
          this.$chartist.plugins.ctPointLabels({ labelOffset: { y: 8 }})
        ],
        chartPadding: {
          right: 90
        },
        fullWidth: true,
        axisX: {
          onlyInteger: true,
          position: 'start',
          offset: 60
        },
        axisY: {
          offset: 220
        },
        horizontalBars: true,
        seriesBarDistance: 20,
      },
      data: {
        labels: [],
        series: []
      }
    }
  },
  computed: mapState('app', ['protocol']),
  created () {
    if (this.protocol.id !== -1) {
      this.updateProtocol(this.protocol.id)
    }
  },
  watch: {
    protocol () {
      if (this.protocol.id !== -1) {
        this.updateProtocol(this.protocol.id)
      }
    }
  },
  methods: {
    async updateProtocol (protocolId) {
      const { data } = await reportAvailability(protocolId)
      this.data.labels = data.map( d => `${d.name} ${d.packaging} (${d.packaging  === 'Labels' ? d.labels?.join(',') : d.dose + d.measure_unit})`)
      this.options.height = 100+50*data.length + 'px'
      this.data.series = []
      this.data.series.push( data.map( d => d.n_available))
      this.data.series.push( data.map( d => d.min_stock ))
    },
  },
}
</script>
<style lang='scss'>
.ct-legend {
    position: relative;
    list-style: none;
    text-align: center;
    margin-bottom: 10px;

    li {
        position: relative;
        padding-left: 23px;
        margin-bottom: 6px;
        margin-right: 30px;
        display: inline-block;

    }

    li:before {
        width: 18px;
        height: 18px;
        position: absolute;
        left: 0;
        content: '';
        border: 3px solid transparent;
        border-radius: 2px;
    }

    li.inactive:before {
        background: transparent;
    }

    &.ct-legend-inside {
        position: absolute;
        top: 0;
        right: 0;
    }

    .ct-series-1:before {
        background-color: orangered;
        border-color: orangered;
    }

    .ct-series-0:before {
        background-color: lightblue;
        border-color: lightblue;
    }
}

.ct-series .ct-label {
  fill: black;
  font-size: 1em;
  font-weight: normal;
  margin-top: 7px;
}

</style>
